import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'users-and-roles.actors-table.intro-view.header',
		defaultMessage: 'Great work starts with a great team!',
		description: 'Header text when a user starts creating team in project',
	},
	text: {
		id: 'users-and-roles.actors-table.intro-view.text',
		defaultMessage:
			"Add the people you want to work on the project, and they'll get a link to join the action.",
		description: 'Body text when a user starts creating team in project',
	},
});
